import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-catalog-loading',
  templateUrl: './catalog-loading.component.html',
  styleUrls: ['./catalog-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogLoadingComponent {
  @Input() isLandScapeTablet: boolean;
  @Input() isDesktop: boolean;
  @Input() isTablet: boolean;
  @Input() isMobile: boolean;
}
